import React from "react";
// import { MDBCarousel, MDBCarouselItem, MDBCarouselCaption } from 'mdb-react-ui-kit';

const Testimonials = () => {
  return (
    <>
      <div className="testimonialWrapper">
        <div className="testimonialHeadBox">
          <div className="gradient-horiz-line mx-auto"></div>
          <p className="top-heading mt-4 text-center">TESTIMONIALS</p>
          <p className="main-gradient-heading text-center">Group LanDev AI</p>
          <span className="sub-heading text-center">
            What Our clients Say About the Transformative Impact{" "}
          </span>
        </div>

        <div
          id="carouselExampleCaptions"
          class="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="0"
              class="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img src="/images/home/white.webp" className="d-block w-100 sliderbg" alt="" />
              <div className="carousel-caption  d-md-block">
                <img className="slider1img" src="/images/home/sliderimg1.png" />

                <p className="sliderText">
                  “Incredible experience with  GroupLanDev AI Construction! They delivered top-notch quality while keeping costs in check. Kudos to the team for their dedication”. - SarahDoe
                </p>
                <h5 className="ownerName">lucas gray</h5>
              </div>
            </div>
            <div class="carousel-item ">
              <img src="/images/home/white.webp" className="d-block w-100 sliderbg" alt="" />
              <div className="carousel-caption d-md-block">
                <img className="slider1img" src="/images/home/sliderimg2.png" />

                <p className="sliderText">
                  "Hats off to GroupLanDev AI Construction! Their speed and efficiency exceeded my expectations. Our project was completed swiftly without compromising quality. Thanks, GroupLanDev AI team!” - JohnBuilder
                </p>
                <h5 className="ownerName">Blanco Brown</h5>
              </div>
            </div>
            <div class="carousel-item ">
              <img src="/images/home/white.webp" className="d-block w-100 sliderbg" alt="" />
              <div className="carousel-caption  d-md-block">
                <img className="slider1img" src="/images/home/Group 179.png" />

                <p className="sliderText">
                  "GroupLanDev AI Construction has been a game-changer! Privacy was a priority, and they delivered. Trustworthy and dependable highly recommended”. - ConstructionJane.
                </p>
                <h5 className="ownerName">Grace Martinez</h5>
              </div>
            </div>
          </div>
          <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon slidersArrowLeft" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon slidersArrowRight" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
